import React, { useState } from 'react';
import QuestionWrapper from '../../../wrappers/question_wrapper/index';

import styles from '../questionnaire.module.css';

export default function YesNoExtra({
  onBack,
  onSubmit,
  title,
  para,
  keyForAnswer,
  yesState,
  answers,
  choices = ['Yes', 'No'],
  extraIndex = 0,
  otherPlaceholder = 'Share your follow up questions here... (Optional)',
}) {
  const [selected, setSelected] = useState(answers[keyForAnswer] || '');
  const [other, setOther] = useState(answers.other || '');

  const submit = (e) => {
    e.preventDefault();
    let newSelected = { [keyForAnswer]: selected };
    if (other !== '') {
      newSelected.other = other;
    }
    onSubmit(newSelected, yesState);
  };

  const onClick = (choice) => {
    if (selected === choice) {
      setSelected('');
      if (selected === choices[extraIndex]) {
        setOther('');
      }
    } else {
      setSelected(choice);
    }
  };

  return (
    <QuestionWrapper onSubmit={submit} onBack={onBack} isDisabled={!selected.length}>
      <h5 className={styles.question}>{title}</h5>
      <p className={styles.question_para}>{para}</p>
      {selected !== '' && selected === choices[extraIndex]
        ? [choices[extraIndex]].map((choice) => (
            <>
              <div key={choice} className={`${styles.tile} ${styles.twoColumn}`}>
                <label
                  key={choice}
                  className={`${styles.preexisting} ${selected.includes(choice) ? styles.active_checkbox : ''}`}
                >
                  <input onClick={() => onClick(choice)} type='checkbox' name={choice} value='value' />
                  {choice}
                </label>
              </div>
              {selected === choices[extraIndex] && choice === selected && (
                <div className='marg-top-0 marg-bottom-20 light marg-center w-100'>
                  <textarea
                    className={`material-input light w-100 marg-top-0`}
                    style={{ backgroundColor: '#fff !important', width: '100%' }}
                    placeholder={otherPlaceholder}
                    type='text'
                    name='other'
                    value={other}
                    onChange={(event) => setOther(event.target.value)}
                  />
                  <span className='bar'></span>
                </div>
              )}
            </>
          ))
        : choices.map((choice) => (
            <div key={choice} className={`${styles.tile} ${styles.twoColumn}`}>
              <label
                key={choice}
                className={`${styles.preexisting} ${selected.includes(choice) ? styles.active_checkbox : ''}`}
              >
                <input onClick={() => onClick(choice)} type='checkbox' name={choice} value='value' />
                {choice}
              </label>
            </div>
          ))}
    </QuestionWrapper>
  );
}
